import { FirebaseApp } from 'firebase/app';
import { IServiceFactory } from '../IServiceFactory';
import { ISaleService } from '../ISaleService';
import { SaleService } from './SaleService';
import { ILogService } from '../ILogService';
import { LogService } from './LogService';
import { ImportDatesService } from './ImportDatesService';
import { IImportDatesService } from '../IImportDatesService';
import { IAccountService } from '../IAccountService';
import { AccountService } from './AccountService';

export class ServiceFactory implements IServiceFactory {
  protected app: FirebaseApp;
  private saleService: ISaleService;
  private logService: ILogService;
  private importDatesService: IImportDatesService;
  private accountService: IAccountService;

  constructor(app: FirebaseApp, accountId: string) {
    console.log('ServiceFactory accountId', accountId);
    this.app = app;
    this.saleService = new SaleService(app, `accounts/${accountId}/salesByProduct`);
    this.logService = new LogService(app, `accounts/${accountId}/logs`);
    this.importDatesService = new ImportDatesService(app, `accounts/${accountId}/counters/import`);
    this.accountService = new AccountService(app, 'accounts');
  }

  setAccountId(accountId: string): void {
    this.saleService = new SaleService(this.app, `accounts/${accountId}/salesByProduct`);
    this.logService = new LogService(this.app, `accounts/${accountId}/logs`);
    this.importDatesService = new ImportDatesService(this.app, `accounts/${accountId}/counters/import`);
    this.accountService = new AccountService(this.app, 'accounts');
  }

  getSaleService(): ISaleService {
    return this.saleService;
  }

  getLogService(): ILogService {
    return this.logService;
  }

  getImportDatesService(): IImportDatesService {
    return this.importDatesService;
  }

  getAccountService(): IAccountService {
    return this.accountService;
  }
}
